import React from 'react'
import { reaction } from 'mobx'
import { customerContainer, accountsContainer } from 'src/models'
import { addressFormInput } from './formInput'
import { CommonForm } from 'src/views/components'
import { getParsedPhoneNumber } from 'src/utils'
import { schema } from '../validationSchema'

class AccountProfilePIIForm extends React.Component {
  //@observable data = ''
  constructor(props) {
    super(props)
    this.state = {
      data: {},
    }
  }

  handleSubmit = formData => {
    this.props.onSubmit(formData)
  }
  setDataResponse = async () => {
    let response = await this.getDataModal()
    let promise = new Promise((resolve, reject) => {
      if (typeof response !== 'undefined') {
        resolve(response)
      } else {
        reject(Error('Promise rejected'))
      }
    })

    promise.then(
      result => {
        this.setState({ data: result })
      },
      function (error) {
        this.setState({ data: error })
      }
    )
  }
  async componentDidMount() {
    reaction(
      () => customerContainer.isProfileCallOver,
      async (isProfileCallOverNewValue, reaction) => {
        await this.setDataResponse()
        reaction.dispose()
      }
    )
  }
  async getProfileFormData(profileResponse = {}) {
    const { phoneNumber = '' } = profileResponse
    if (phoneNumber != '') {
      const parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

      const phone = parsedPhoneNumber?.phoneNumberCode
      const phoneCountry = parsedPhoneNumber?.phoneCountry

      Object.keys(profileResponse).forEach(item => {
        if (
          item === 'phoneNumber' &&
          typeof profileResponse[item] !== undefined
        ) {
          profileResponse['parsedPhoneNumber'] = phone
        }
      })

      profileResponse['phoneCountry'] = phoneCountry || ''
    }

    return profileResponse
  }
  async getDataModal() {
    const {
      accountPrefillData = {},
      constructStyle,
      accountSettings,
      isSelfOnBoard = false,
      buyerAdminMailId = '',
    } = this.props.data
    const { isAddressDisabled = false } = this.props
    const addressData = accountsContainer?.profileResponse?.addresses?.[0] || {}
    const addressproPrpperties =
      accountsContainer?.profileResponse?.properties?.[0] || {}
    const identity =
      (await this.getProfileFormData(customerContainer?.profileResponse)) || {} //customerContainer?.profileResponse || {}

    return addressFormInput({
      accountPrefillData,
      accountSettings,
      buyerAdminMailId,
      identity,
      addressData,
      addressproPrpperties,
      isAddressDisabled,
    }, this.props?.onClickPhoneVerifyBtn || '')
  }

  render() {
    //const data = this.getDataModal()
    const { constructStyle, isSelfOnBoard = false } = this.props.data
    return (
      <>
        {this.state.data?.length > 0 && (
          <CommonForm
            classNameValue={constructStyle}
            formTypeJson={this.state.data}
            schema={schema(isSelfOnBoard)}
            reference={this.props.refId}
            onSubmit={formData => this.handleSubmit(formData)}
            customHandleBlur={this.props.customHandleBlur}
          />
        )}
      </>
    )
  }
}

export default AccountProfilePIIForm
export { AccountProfilePIIForm }
